import Dashboard from 'containers/Dashboard';

const Home = ({ props }) => {
  return <Dashboard {...props} />;
};
Home.propTypes = {};

export default Home;
